import React from "react";
import PropTypes from "prop-types";
import { makeStyles, Typography, Link, Box, Chip } from "@material-ui/core";
import { NavLink as RouterLink } from "react-router-dom";
import { FileIcon, defaultStyles } from "react-file-icon";
import SvgIcon from "@material-ui/core/SvgIcon";
import FolderIcon from "@material-ui/icons/Folder";
import { Alert } from "@material-ui/lab";

const useStyles = makeStyles((theme) => ({
  root: {},
  docstructicon: {
    "& > svg": {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(1),
      fontSize: 32,
    },
  },
}));

const DocumentStructName = ({
  document,
  openDocumentHandler,
  markVotings,
  ...rest
}) => {
  const classes = useStyles();

  let icon;
  let nameLink;

  if (document.nodeType === "1") {
    icon = (
      <div className={classes.docstructicon}>
        <SvgIcon>
          <FolderIcon />
        </SvgIcon>
      </div>
    );
    nameLink = (
      <Box>
        <Typography color="textPrimary" variant="body1">
          <Link component={RouterLink} to={`/dokumenty/${document.id}`}>
            {document.name}
          </Link>
        </Typography>
        {document.description ? (
          <Typography variant="caption" color="textSecondary">
            {document.description}
          </Typography>
        ) : (
          <></>
        )}
      </Box>
    );
  } else {
    icon = (
      <div className={classes.docstructicon}>
        <SvgIcon>
          <FileIcon
            extension={document.fileType}
            {...defaultStyles[document.fileType]}
          />
        </SvgIcon>
      </div>
    );
    nameLink = (
      <Box>
        <Typography color="textPrimary" variant="body1">
          <Link href="#" onClick={(e) => openDocumentHandler(e, document.id)}>
            {document.name}
          </Link>
        </Typography>
        {markVotings && document.votings?.length > 0 ? (
          <Alert severity="info">
            <b>Głosowania związane z dokumentem</b>
            <ul>
              {document.votings.map((voting) => {
                return (
                  <Typography
                    color="textPrimary"
                    variant="caption"
                    component="li"
                  >
                    {voting.title}
                  </Typography>
                );
              })}
            </ul>
          </Alert>
        ) : (
          <></>
        )}
      </Box>
    );
  }

  return (
    <Box alignItems="center" display="flex" height="2%">
      {icon}
      {nameLink}
    </Box>
  );
};

document.propTypes = {
  className: PropTypes.object,
};

export default DocumentStructName;
